// Mahan Oven
import React from "react";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import {
   ClockSettingSixRow, CommonRows, CreelTensionRow, DancerArmTensionRow, InputRangeRow,
   MinMaxRow, MinMaxTrueFalseRow, RadioButtonRow, RadioLabelCol, RecipeRow, RunTimeRow,
} from "./index";

export default function MachineMahanOven() {
   const { machineSetup } = useMachineSetupContextState();
   return (
      <>
         <InputRangeRow
            titleProp={"Size Box Roll Pressure"}
            descriptionProp={"psi"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99}
            propertyNameProp={"boxPressure"}
            errorDialogueProp={"0-99"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Over Feed/Size Box Stretch"}
            descriptionProp={"%"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={-7.0}
            maxProp={7.0}
            propertyNameProp={"boxStretch"} //legacy code said -5.0 to 5.0 but the site says -7.0 to 7.0
            errorDialogueProp={"-7.0-7.0"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Bond Temperature"}
            descriptionProp={"+/- 10F"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={60}
            maxProp={250}
            propertyNameProp={"bondTemp"}
            errorDialogueProp={"60-250"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Box Setting"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={3}
            propertyNameProp={"boxSetting"}
            errorDialogueProp={"0-3"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Wiper Weight"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            string
            propertyNameProp={"wiperWeight"}
            errorDialogueProp={"1-9,999,999 only"}
            floatProp={false}
         />
         <ClockSettingSixRow />
         <RunTimeRow />
         <RecipeRow />
         <MinMaxRow
            titleProp={"#1 Oven Temp"}
            descriptionProp="F"
            minProp1={60}
            maxProp1={600}
            floatProp1={false}
            errorProp1={"60-600 only"}
            minProp2={60}
            maxProp2={600}
            floatProp2={false}
            errorProp2={"60-600 only"}
            valueProp1={"oven1TempTop"}
            valueProp2={"oven1TempBtm"}
            differentDisplayProp1={"Top"}
            differentDisplayProp2={"Bottom"}
         />
         <MinMaxTrueFalseRow
            titleProp={"#1 Oven Control Panel"}
            onChangeProp1={"oven1PanelTop"}
            onChangeProp2={"oven1PanelBtm"}
            groupNameProp1={"oven1aPanelGroup"}
            groupNameProp2={"oven1bPanelGroup"}
         />
         <MinMaxRow
            titleProp={"#2 Oven Temp"}
            descriptionProp="F"
            minProp1={60}
            maxProp1={600}
            floatProp1={false}
            errorProp1={"60-600 only"}
            minProp2={60}
            maxProp2={600}
            floatProp2={false}
            errorProp2={"60-600 only"}
            valueProp1={"oven2TempTop"}
            valueProp2={"oven2TempBtm"}
            differentDisplayProp1={"Top"}
            differentDisplayProp2={"Bottom"}
         />
         <MinMaxTrueFalseRow
            titleProp={"#2 Oven Control Panel"}
            onChangeProp1={"oven2PanelTop"}
            onChangeProp2={"oven2PanelBtm"}
            groupNameProp1={"oven2aPanelGroup"}
            groupNameProp2={"oven2bPanelGroup"}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"# Passes Top to Btm"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"passesGroup"}
               valueProp={1}
               onChangeProp={"numberPasses"}
               displayProp={"1"}
               stringProp
            />
            <RadioLabelCol
               groupNameProp={"passesGroup"}
               valueProp={3}
               onChangeProp={"numberPasses"}
               displayProp={"3"}
               stringProp
            />
         </RadioButtonRow>
         <InputRangeRow
            titleProp={"Pre-Feeder Roll Pressure"}
            descriptionProp={"psi"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99}
            propertyNameProp={"preFeedPressure"}
            errorDialogueProp={"0-99 only"}
            floatProp={false}
         />
         <MinMaxRow
            titleProp={"Delivery Speed"}
            descriptionProp="m/min"
            minProp1={0}
            maxProp1={300}
            floatProp1={false}
            errorProp1={"0-300 only"}
            minProp2={0}
            maxProp2={300}
            floatProp2={false}
            errorProp2={"0-300 only"}
            valueProp1={"speedSlow"}
            valueProp2={"speedFast"}
         />
         <InputRangeRow
            titleProp={"Pre-Feeder Oscillator Setting"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={10}
            propertyNameProp={"preFeedSetting"}
            errorDialogueProp={"0-10 only"}
            floatProp={false}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"Creel Type"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"creelTypeGroup"}
               valueProp={"Standard"}
               onChangeProp={"creelType"}
               displayProp={"Standard"}
               stringProp
            />
            <RadioLabelCol
               groupNameProp={"creelTypeGroup"}
               valueProp={"Roll Off"}
               onChangeProp={"creelType"}
               displayProp={"Roll Off"}
               stringProp
            />
         </RadioButtonRow>
         <DancerArmTensionRow />
         {machineSetup.extendedPropertyJson?.creelType === "Standard" && (
            <>
               <CreelTensionRow />
               <InputRangeRow
                  titleProp={"Zone B Bar Position"}
                  descriptionProp={"degrees"}
                  sizeProp={4}
                  colSizeProp={3}
                  typeProp={"text"}
                  minProp={0}
                  maxProp={360}
                  propertyNameProp={"zoneBBarPos"}
                  errorDialogueProp={"0-360 only"}
                  floatProp={false}
               />
               <MinMaxRow
                  titleProp={"Zone B Tension"}
                  descriptionProp="g"
                  minProp1={1}
                  maxProp1={600}
                  floatProp1={false}
                  errorProp1={"1-600 only"}
                  minProp2={1}
                  maxProp2={600}
                  floatProp2={false}
                  errorProp2={"1-600 only"}
                  valueProp1={"zoneBTensionMin"}
                  valueProp2={"zoneBTensionMax"}
               />
               <MinMaxRow
                  titleProp={"Zone C Tension"}
                  descriptionProp="g"
                  minProp1={1}
                  maxProp1={600}
                  floatProp1={false}
                  errorProp1={"1-600 only"}
                  minProp2={1}
                  maxProp2={600}
                  floatProp2={false}
                  errorProp2={"1-600 only"}
                  valueProp1={"zoneCTensionMin"}
                  valueProp2={"zoneCTensionMax"}
               />
            </>
         )}
         <CommonRows />
      </>
   );
}
